import { CircularProgress } from "@mui/material";
import React from "react";

const Loader = () => {
  return (
    <div className="h-[90vh] w-full flex justify-center items-center">
      <CircularProgress className="text-slate-500" />
    </div>
  );
};

export default Loader;
